import { render } from "./UpdateGuiTheme.vue?vue&type=template&id=dac1a49c&scoped=true"
import script from "./UpdateGuiTheme.vue?vue&type=script&lang=js"
export * from "./UpdateGuiTheme.vue?vue&type=script&lang=js"

import "./UpdateGuiTheme.vue?vue&type=style&index=0&id=dac1a49c&lang=scss&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dac1a49c"]])

export default __exports__